import React from 'react';
import cn from 'classnames';
import styles from './playButton.module.scss';

type PlayButtonProps = {
    onClick: () => void;
    withText?: boolean;
    imgUrl?: string;
};

export const PlayButton = ({ onClick, imgUrl = '' }: PlayButtonProps) => {
    return (
        <div
            onClick={onClick}
            className={cn(styles.videoButton, {
                [`${styles.videoButtonWihText}`]: !imgUrl,
                [`${styles.videoButtonWihThumbnail}`]: imgUrl?.length > 0,
            })}
        >
            {imgUrl && <img className={styles.videoThumbnail} src={imgUrl} alt='video thumbnail'></img>}
            <div
                role='button'
                className={styles.playButton}
                title='Play video'
                tabIndex={0}
                aria-label='Play video Wedding spot 2022 Video. Opens in a modal'
            >
                <div className={styles.playButtonSize} />
                <div className={styles.arrowSize}>
                    <div className={styles.arrowSizeRatio} />
                    <div className={styles.arrow} />
                </div>
            </div>
        </div>
    );
};
